import { companiesRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';

export const useImportRatesFile = () =>
  useMutation<unknown, unknown, FormData>((data) =>
    companiesRepo.addRatesFile(data),
  );
